<script setup>
import CompetitorBacklinkStats from "@/components/competition/partials/backlinks/BacklinkStats.vue";
import CompetitorBacklinksSearch from "@/components/competition/partials/backlinks/BacklinksSearch.vue";
import CompetitorBacklinksTable from "@/components/competition/partials/backlinks/BacklinksTable.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const backlinksRan = computed(() => store.getters['competitionV2/backlinksRan']);
</script>

<template>
  <div>
    <LoadingBlock v-if="!backlinksRan">
      Waiting for backlinks data
    </LoadingBlock>
    <div v-else>
      <CompetitorBacklinkStats class="tw-px-8 tw-pt-4 tw-pb-8 tw-border-b" />
      <CompetitorBacklinksSearch class="tw-px-8 tw-py-8" />
      <CompetitorBacklinksTable class="tw-px-8" />
    </div>
  </div>
</template>